import React from "react";
import "./TigerButton.scss";
import {BiArrowBack} from "react-icons/bi";
import Strings from "../../config/Strings";
import {TigerButton} from "./TigerButton";

export const BackButton = (props) => {
    const { onClick, disabled = false, } = props;
    return (
            <div className="back-button">
                <TigerButton
                        className={"btn-ci-outlined back-button btn-ci-hover small-height"}
                        variant="purple"
                        disabled={disabled}
                        onClick={onClick}
                        outline={true}
                ><BiArrowBack/> {Strings.BACK_BUTTON}</TigerButton>
            </div>
    );
}
